<template>
  <section
    class="product-list">
    <div
      v-for="qualification in qualifiedQualifications"
      :key="qualification.productId"
      class="product"
    >
      <ProductCard
        :qualification="qualification"
        :tdc="tdc"
      />
    </div>
    <div
      class="not-qualified"
      v-show="qualifiedQualifications.length === 0 && qualificationCountries.length == 0"
    >
      <div v-if="qualificationLoadError">
        <h2>{{ tdc.tdc_loadQualificationsError }}</h2>
      </div>
      <div v-else>
        <h2>{{ tdc.tdc_noItemsTitle }}</h2>
        <p>{{ tdc.tdc_noItemsText }}</p>
      </div>
      <button @click="goToHome" class="primary-outline">
        {{ tdc.tdc_backToHome }}
      </button>
    </div>
  </section>
</template>

<script>

import {
  RunConfigService,
  UrlService
} from '@nuskin/ns-util'

import ProductCard from './ProductCard.vue'

export default {
  components: {
    ProductCard,
  },
  props: {
    qualificationLoadError: Boolean,
    qualifications: {
      default: () => [],
      type: Array
    },
    tdc: Object,
  },
  watch: {
    qualifications: function() {
      this.setupQualifiedQualificationsList()
    }
  },
  methods: {
    setupQualifiedQualificationsList() {
      const country = RunConfigService.getRunConfig().country
      this.qualifiedQualifications = Object.values(this.qualifications)
        .filter(qualification => {
          return qualification.quantity > 0 && qualification.markets.includes(country)
        })
      // eslint-disable-next-line no-console
      this.qualificationCountries =
        Object.values(this.qualifications)
          .filter(qualification => qualification.quantity > 0 ||
          qualification.sharedList.reduce((total, sharedItem) => total + sharedItem.canReclaim, 0) > 0
          )
          .map(qualification => qualification.markets)
          .flat()
    },
    goToHome() {
      window.location = UrlService.getAemLocaleUrl() + 'home.html'
    },
  },
  data() {
    return {
      country: 'US',
      qualifiedQualifications: [],
      qualificationCountries: []
    }
  },
  mounted() {
    this.setupQualifiedQualificationsList()
  }
}
</script>

<style lang="scss">

.product-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.product-list > div {
  width: 355px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px;
  box-sizing: border-box;
  justify-content: space-between;
}

.product-list > div button {
  margin-bottom: 15px;
  width: 100%;
}

.product-list .product {
  padding: 20px 30px;
  min-height: 580px;
}

.product-list > div > div {
  text-align: center;
}

.not-qualified {
  text-align: center;

  h2 {
    font-size: 22px;
    line-height: 27px;
    margin-bottom: 5px;
    font-weight: var(--font-weight-bold);
    font-family: var(--font-family-primary);
  }

  h2, p {
    max-width: 260px;
    margin: 0 auto 20px;
  }

  button {
    background: white;
    max-width: 260px;
    margin: auto;
  }

  button:hover {
  background: rgba(255, 255, 255, 0.75);
  }
}

@media (max-width: 450px) {
  .product-list > div {
    margin: 10px 40px;
  }

  .product-list .product {
    padding: 20px;
  }
}

@media (max-width: 320px) {
  .product-list > div {
    margin: 10px 20px;
  }
}
</style>
